/**
 * Service: inventoryApi
 *
 * Maps to addons api
 */
angular.module('acme.common.service.inventoryApi', [
  'acme.common.factory.apiVersion',
  'acme.common.factory.QueryStringBuilder'
])
.service('InventoryApiService', ['$http', '$timeout', '$q', 'ApiVersionFactory', 'QueryStringBuilderFactory', function($http, $timeout, $q, ApiVersionFactory, QueryStringBuilderFactory) {

    return {

      service: '',

      init: function(endpoint) {
        this.service = endpoint + '/addons';
        return this;
      },

      list: function(props) {
        var q = '',
            av = new ApiVersionFactory();

        if(props) {
          var qs = new QueryStringBuilderFactory({
            props: props,
            fields: {
              optional: ['sortDirection', 'sortField', 'pageSize', 'page', 'search', 'saleChannel', 'addonTypes']
            }
          });
          q = qs.query;
        }
        return $http({
          method: 'get',
          url: av.init({ url: this.service + q, version: 'v2' })
        });
      },

      create: function(props) {
        var av = new ApiVersionFactory();

        return $http({
          method: 'post',
          url: av.init({ url: this.service, version: 'v2' }),
          data: {
            sku: props.sku,
            name: props.name,
            type: props.type,
            order: props.order,
            price: props.price,
            basePrice: props.basePrice,
            active: props.active,
            quantity: props.quantity,
            printTicket: props.printTicket,
            salesChannels: props.salesChannels,
            description: props.description
          }
        });
      },

      remove: function(id) {
        var av = new ApiVersionFactory();

        return $http({
          method: 'delete',
          url: av.init({ url: this.service + '/' + id, version: 'v2' })
        });
      },

      detail: function(id) {
        var av = new ApiVersionFactory();

        return $http({
          method: 'get',
          url: av.init({ url: this.service + '/' + id, version: 'v2' })
        });
      },

      update: function(props) {
        var av = new ApiVersionFactory();

        return $http({
          method: 'put',
          url: av.init({ url: this.service, version: 'v2' }),
          data: {
            id: props.id,
            sku: props.sku,
            name: props.name,
            type: props.type,
            order: props.order,
            price: props.price,
            basePrice: props.basePrice,
            active: props.active,
            quantity: props.quantity,
            printTicket: props.printTicket,
            resourceId: props.resourceId,
            salesChannels: props.salesChannels,
            description: props.description
          }
        });
      }

    };

}]);